<div class="dialog--title"
  cdkDrag cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragFreeDragPosition]="position"
  (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysTextDialog.editEmployeeRecord_employeeInfo | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysTextDialog.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <div class="main-container">

    <div class="column-container">
      <div class="employee">
        <div class="sub-employee">
          <div class="ee-column">
            <app-input-field
              [label]="data.sysTextDialog.editEmployeeRecord_firstName"
              [control]="form.controls.firstName"
              [group]="form"
              [icon]="'person'"
            ></app-input-field>
          </div>

          <div class="left-margin">
            <app-input-field
              [label]="data.sysTextDialog.editEmployeeRecord_middleName"
              [control]="form.controls.middleName"
              [group]="form"
              [hideIconSpace]="!(isMobile$ | async)"
            ></app-input-field>
          </div>
        </div>

        <div class="sub-employee">
          <div class="ee-column">
            <app-input-field
              [label]="data.sysTextDialog.editEmployeeRecord_lastName"
              [control]="form.controls.lastName"
              [group]="form"
            ></app-input-field>
          </div>

          <div class="left-margin">
            <app-input-field
              [label]="data.sysTextDialog.editEmployeeRecord_suffix"
              [control]="form.controls.suffix"
              [group]="form"
              [hideIconSpace]="!(isMobile$ | async)"
            ></app-input-field>
          </div>
        </div>
      </div>

      <app-input-field
        [label]="data.sysTextDialog.editEmployeeRecord_preferredName"
        [control]="form.controls.preferredName"
        [group]="form"
      ></app-input-field>

      <app-email-field-group
        [group]="form"
        [workEmailControl]="form.controls.workEmail"
        [isWorkEmailPreferredControl]="form.controls.workEmailChecked"
        [personalEmailControl]="form.controls.personalEmail"
        [isPersonalEmailPreferredControl]="form.controls.personalEmailChecked">
      </app-email-field-group>

      <app-input-field
        [group]="form"
        [control]="form.controls.workPhone"
        [icon]="'phone'"
        [label]="data.sysTextDialog.editEmployeeRecord_workPhone"
        [inputType]="'string'"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
      ></app-input-field>

      <app-input-field
        [group]="form"
        [control]="form.controls.personalPhone"
        [label]="data.sysTextDialog.editEmployeeRecord_personalPhone"
        [inputType]="'string'"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
      ></app-input-field>
    </div>

    <div class="column-container">
      <app-input-field
        [group]="form"
        [control]="form.controls.company"
        [icon]="'business'"
        [label]="data.sysTextDialog.editEmployeeRecord_company"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
      ></app-input-field>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.workLocation"
        [icon]="'location_on'"
        [label]="data.sysTextDialog.editEmployeeRecord_workLocation"
        [options]="data.workLocations"
        [isSimple]="true"
      ></app-autocomplete-field>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.jobTitle"
        [icon]="'work'"
        [label]="data.sysTextDialog.editEmployeeRecord_jobTitle"
        [options]="data.jobTitles"
        [isSimple]="true"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
      ></app-autocomplete-field>

      <app-input-field
        [group]="form"
        [control]="form.controls.city"
        [icon]="'location_city'"
        [label]="data.sysTextDialog.editEmployeeRecord_city"
        [isHintHighlighted]="false"
        [isHintWarning]="true"
      ></app-input-field>

      <div class="select-container">
        <mat-icon [ngClass]="{ focus: select.focused }">map</mat-icon>
        <mat-form-field color="accent">
          <mat-label>{{ data.sysTextDialog.editEmployeeRecord_state | titlecase }}</mat-label>
          <mat-select #select="matSelect" [formControl]="form.controls.stateId" [value]="data.employeeRecord.stateId" disableOptionCentering panelClass="dropDownSelect" panelWidth="fit-content">
            <mat-option [value]="null"></mat-option>
            @for (state of data.stateOptions; track state) {
              <mat-option [value]="state.id">
                <span>{{ state.description }}</span>
              </mat-option>
            }
          </mat-select>
          <!-- mat hint for spacing -->
          <mat-hint></mat-hint>
          <mat-error>{{ form.controls.stateId.errors?.msError }}</mat-error>
          @if (form.controls.stateId.errors?.required) {
            <mat-error>{{ data.sysText.editEmployeeRecord_state | titlecase }} {{data.sysText.required}}</mat-error>
          }
        </mat-form-field>
        <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
        <button
          type="button"
          class="button-reset info-button"
          [attr.aria-label]="data.sysTextDialog.moreInformation_ariaLabel"
          [matTooltip]="data.sysTextDialog.editEmployeeRecord_stateInfo"
          [matTooltipShowDelay]="500"
          matTooltipPosition="above">
          <mat-icon class="button-icon">info_outline</mat-icon>
        </button>
      </div>

      <div class="contact-group">
        @for (sv of supervisorsArray.controls; track sv; let i = $index) {
          <div class="group-form-container">
            <div class="contact-container">
              <div class="input-auto-field" [ngClass]="{'w-90': (supervisorsArray.controls.length > 1)}">
                <app-autocomplete-field
                  [group]="sv"
                  [control]="sv.controls.employeeId"
                  [icon]="i > 0 ? '' : 'person'"
                  [label]="data.sysTextDialog.editEmployeeRecord_supervisor"
                  [options]="data.supervisorOptions"
                  [interfaceName]="data.sysTextDialog.editEmployeeRecord_supervisor"
                  [isDisabled]="isNewSupervisor[i]"
                  (hintClick)="onAddSupervisorContact(i)"
                  [hasClickableHint]="true"
                  [showSearchIcon]="true"
                  [comboMsError]="true"
                ></app-autocomplete-field>
              </div>
              @if (supervisorsArray.controls.length > 1) {
                <button
                  mat-icon-button
                  [attr.aria-label]="data.sysTextDialog.remove_ariaLabel"
                  [disableRipple]="true"
                  (click)="onRemoveSupervisorContact(i)">
                  <mat-icon [ngClass]="{'accent': true, 'margin-bottom-17': !(isMobile$ | async)}">close</mat-icon>
                </button>
              }
            </div>
            @if (isNewSupervisor[i]) {
              <div class="new-employee">
                <div class="sub-employee">
                  <div class="new-ee-column">
                    <app-input-field
                      [label]="data.sysTextDialog.editEmployeeRecord_firstName"
                      [ariaLabel]="data.sysTextDialog.editEmployeeRecord_supervisor + ' ' + data.sysTextDialog.editEmployeeRecord_firstName"
                      [control]="sv.controls.firstName"
                      [hideIconSpace]="true"
                      [group]="sv"
                    ></app-input-field>
                  </div>
                  <div class="new-ee-column left-margin">
                    <app-input-field
                      [label]="data.sysTextDialog.editEmployeeRecord_middleName"
                      [ariaLabel]="data.sysTextDialog.editEmployeeRecord_supervisor + ' ' + data.sysTextDialog.editEmployeeRecord_middleName"
                      [control]="sv.controls.middleName"
                      [hideIconSpace]="true"
                      [group]="sv"
                    ></app-input-field>
                  </div>
                </div>
                <div class="sub-employee">
                  <div class="new-ee-column">
                    <app-input-field
                      [label]="data.sysTextDialog.editEmployeeRecord_lastName"
                      [ariaLabel]="data.sysTextDialog.editEmployeeRecord_supervisor + ' ' + data.sysTextDialog.editEmployeeRecord_lastName"
                      [control]="sv.controls.lastName"
                      [hideIconSpace]="true"
                      [group]="sv"
                    ></app-input-field>
                  </div>
                  <div class="new-ee-column left-margin">
                    <app-input-field
                      [label]="data.sysTextDialog.editEmployeeRecord_suffix"
                      [ariaLabel]="data.sysTextDialog.editEmployeeRecord_supervisor + ' ' + data.sysTextDialog.editEmployeeRecord_suffix"
                      [control]="sv.controls.suffix"
                      [hideIconSpace]="true"
                      [group]="sv"
                    ></app-input-field>
                  </div>
                </div>
                <div class="new-ee-full-column">
                  <app-input-field
                    [label]="data.sysTextDialog.editEmployeeRecord_preferredName"
                    [ariaLabel]="data.sysTextDialog.editEmployeeRecord_supervisor + ' ' + data.sysTextDialog.editEmployeeRecord_preferredName"
                    [control]="sv.controls.preferredName"
                    [group]="sv"
                    [hideIconSpace]="true"
                  ></app-input-field>
                </div>
                <app-email-field-group
                  [ariaLabelPrefix]="data.sysTextDialog.editEmployeeRecord_supervisor"
                  [group]="form"
                  [hideIconSpace]="true"
                  [workEmailControl]="sv.controls.workEmail"
                  [isWorkEmailPreferredControl]="sv.controls.workEmailChecked"
                  [personalEmailControl]="sv.controls.personalEmail"
                  [isPersonalEmailPreferredControl]="sv.controls.personalEmailChecked">
                </app-email-field-group>
                <div class="sub-employee">
                  <div class="new-ee-column">
                    <app-input-field
                      [label]="data.sysTextDialog.editEmployeeRecord_workPhone"
                      [ariaLabel]="data.sysTextDialog.editEmployeeRecord_supervisor + ' ' + data.sysTextDialog.editEmployeeRecord_workPhone"
                      [control]="sv.controls.workPhone"
                      [hideIconSpace]="true"
                      [group]="sv"
                    ></app-input-field>
                  </div>
                  <div class="new-ee-column left-margin">
                    <app-input-field
                      [label]="data.sysTextDialog.editEmployeeRecord_personalPhone"
                      [ariaLabel]="data.sysTextDialog.editEmployeeRecord_supervisor + ' ' + data.sysTextDialog.editEmployeeRecord_personalPhone"
                      [control]="sv.controls.personalPhone"
                      [hideIconSpace]="true"
                      [group]="sv"
                    ></app-input-field>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <button
          #addSupervisorButton
          (click)="addSupervisorFormGroup()"
          mat-flat-button
          color="accent"
          class="button add-additional-button">
          {{data.sysTextDialog.addAdditionalSupervisor}}
        </button>
      </div>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.hrManagerId"
        [icon]="'supervisor_account'"
        [label]="data.sysTextDialog.editEmployeeRecord_hrManager"
        [options]="data.hrManagerOptions"
        [interfaceName]="data.sysTextDialog.editEmployeeRecord_hrManager"
        [isDisabled]="isNewHrManager"
        (hintClick)="onHrManagerHintClick()"
        [hasClickableHint]="true"
        [showSearchIcon]="true"
        [showHintAndError]="true"
        [shouldCasePipe]="false"
      ></app-autocomplete-field>

      @if (isNewHrManager) {
        <div class="new-employee">
          <div class="sub-employee">
            <div class="new-ee-column">
              <app-input-field
                [label]="data.sysTextDialog.editEmployeeRecord_firstName"
                [ariaLabel]="data.sysTextDialog.editEmployeeRecord_hrManager + ' ' + data.sysTextDialog.editEmployeeRecord_firstName"
                [control]="newEmployeeHrManager.controls.firstName"
                [hideIconSpace]="true"
                [group]="newEmployeeHrManager"
              ></app-input-field>
            </div>
            <div class="new-ee-column left-margin">
              <app-input-field
                [label]="data.sysTextDialog.editEmployeeRecord_middleName"
                [ariaLabel]="data.sysTextDialog.editEmployeeRecord_hrManager + ' ' + data.sysTextDialog.editEmployeeRecord_middleName"
                [control]="newEmployeeHrManager.controls.middleName"
                [hideIconSpace]="true"
                [group]="newEmployeeHrManager"
              ></app-input-field>
            </div>
          </div>
          <div class="sub-employee">
            <div class="new-ee-column">
              <app-input-field
                [label]="data.sysTextDialog.editEmployeeRecord_lastName"
                [ariaLabel]="data.sysTextDialog.editEmployeeRecord_hrManager + ' ' + data.sysTextDialog.editEmployeeRecord_lastName"
                [control]="newEmployeeHrManager.controls.lastName"
                [hideIconSpace]="true"
                [group]="newEmployeeHrManager"
              ></app-input-field>
            </div>
            <div class="new-ee-column left-margin">
              <app-input-field
                [label]="data.sysTextDialog.editEmployeeRecord_suffix"
                [ariaLabel]="data.sysTextDialog.editEmployeeRecord_hrManager + ' ' + data.sysTextDialog.editEmployeeRecord_suffix"
                [control]="newEmployeeHrManager.controls.suffix"
                [hideIconSpace]="true"
                [group]="newEmployeeHrManager"
              ></app-input-field>
            </div>
          </div>
          <div class="new-ee-full-column">
            <div>
              <app-input-field
                [label]="data.sysTextDialog.editEmployeeRecord_preferredName"
                [ariaLabel]="data.sysTextDialog.editEmployeeRecord_hrManager + ' ' + data.sysTextDialog.editEmployeeRecord_preferredName"
                [control]="newEmployeeHrManager.controls.preferredName"
                [group]="newEmployeeHrManager"
                [hideIconSpace]="true"
              ></app-input-field>
            </div>
          </div>
          <app-email-field-group
            [ariaLabelPrefix]="data.sysTextDialog.editEmployeeRecord_hrManager"
            [group]="form"
            [hideIconSpace]="true"
            [workEmailControl]="newEmployeeHrManager.controls.workEmail"
            [isWorkEmailPreferredControl]="newEmployeeHrManager.controls.workEmailChecked"
            [personalEmailControl]="newEmployeeHrManager.controls.personalEmail"
            [isPersonalEmailPreferredControl]="newEmployeeHrManager.controls.personalEmailChecked">
          </app-email-field-group>
          <div class="sub-employee">
            <div class="new-ee-column">
              <app-input-field
                [group]="newEmployeeHrManager"
                [control]="newEmployeeHrManager.controls.workPhone"
                [hideIconSpace]="true"
                [label]="data.sysTextDialog.editEmployeeRecord_workPhone"
                [ariaLabel]="data.sysTextDialog.editEmployeeRecord_hrManager + ' ' + data.sysTextDialog.editEmployeeRecord_workPhone"
                [inputType]="'string'"
              ></app-input-field>
            </div>
            <div class="new-ee-column left-margin">
              <app-input-field
                [group]="newEmployeeHrManager"
                [control]="newEmployeeHrManager.controls.personalPhone"
                [hideIconSpace]="true"
                [label]="data.sysTextDialog.editEmployeeRecord_personalPhone"
                [ariaLabel]="data.sysTextDialog.editEmployeeRecord_hrManager + ' ' + data.sysTextDialog.editEmployeeRecord_personalPhone"
                [inputType]="'string'"
              ></app-input-field>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="main-container">
    <div class="column-container">
      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.employmentStatus"
        [icon]="'badge'"
        [label]="data.sysTextDialog.editEmployeeRecord_employmentStatus"
        [options]="data.employmentStatuses"
        [isSimple]="true"
      ></app-autocomplete-field>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.employeeType"
        [icon]="'badge'"
        [label]="data.sysTextDialog.editEmployeeRecord_employeeType"
        [options]="data.employeeTypes"
        [isSimple]="true"
      ></app-autocomplete-field>

      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.payType"
        [icon]="'badge'"
        [label]="data.sysTextDialog.editEmployeeRecord_payType"
        [options]="data.payTypes"
        [isSimple]="true"
      ></app-autocomplete-field>

      <app-date-field
        [group]="form"
        [control]="form.controls.hireDate"
        [icon]="'today'"
        [label]="data.sysTextDialog.editEmployeeRecord_hireDate"
      ></app-date-field>

      <app-date-field
        [group]="form"
        [control]="form.controls.originalHireDate"
        [icon]="'today'"
        [label]="data.sysTextDialog.editEmployeeRecord_originalHireDate"
      ></app-date-field>

      <app-date-field
        [group]="form"
        [control]="form.controls.lastTerminationDate"
        [icon]="'today'"
        [label]="data.sysTextDialog.editEmployeeRecord_lastTerminationDate"
      ></app-date-field>
    </div>

    <div class="column-container">
      <app-text-area
        [control]="form.controls.fixedLeaveYearStart"
        [label]="data.sysTextDialog.editEmployeeRecord_fixedLeaveYearStart"
        [info]="data.sysTextDialog.editEmployeeRecord_fixedLeaveYearStart_info"
        [icon]="'today'"
      ></app-text-area>

      @if (data.employeeRecord.leaveHoursBanks.showBank1Hours) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank1FirstLeaveUsageDate"
          [icon]="'today'"
          [label]="data.sysTextDialog.editEmployeeRecord_bank1FirstLeaveUsageDate | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [info]="data.sysTextDialog.editEmployeeRecord_bank1FirstLeaveUsageDate_info | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [dontCapitalizeFirst]=true
        ></app-date-field>
      }

      @if (data.employeeRecord.leaveHoursBanks.showBank2Hours) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank2FirstLeaveUsageDate"
          [icon]="'today'"
          [label]="data.sysTextDialog.editEmployeeRecord_bank2FirstLeaveUsageDate | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [info]="data.sysTextDialog.editEmployeeRecord_bank2FirstLeaveUsageDate_info | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [dontCapitalizeFirst]=true
        ></app-date-field>
      }

      @if (data.employeeRecord.leaveHoursBanks.showBank3Hours) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank3FirstLeaveUsageDate"
          [icon]="'today'"
          [label]="data.sysTextDialog.editEmployeeRecord_bank3FirstLeaveUsageDate | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [info]="data.sysTextDialog.editEmployeeRecord_bank3FirstLeaveUsageDate_info | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [dontCapitalizeFirst]=true
        ></app-date-field>
      }

      @if (data.employeeRecord.leaveHoursBanks.showBank4Hours) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank4FirstLeaveUsageDate"
          [icon]="'today'"
          [label]="data.sysTextDialog.editEmployeeRecord_bank4FirstLeaveUsageDate | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [info]="data.sysTextDialog.editEmployeeRecord_bank4FirstLeaveUsageDate_info | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [dontCapitalizeFirst]=true
        ></app-date-field>
      }

      @if (data.employeeRecord.leaveHoursBanks.showBank5Hours) {
        <app-date-field
          [group]="form"
          [control]="form.controls.bank5FirstLeaveUsageDate"
          [icon]="'today'"
          [label]="data.sysTextDialog.editEmployeeRecord_bank5FirstLeaveUsageDate | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [info]="data.sysTextDialog.editEmployeeRecord_bank5FirstLeaveUsageDate_info | replaceBankNames: data.employeeRecord.leaveHoursBanks"
          [dontCapitalizeFirst]=true
        ></app-date-field>
      }
    </div>
  </div>

  @if (form.controls.userDefinedFields.controls.length > 0) {
    <div class="main-container">
      <div class="column-container">
        @for(userDefinedFieldGroup of positionUserDefinedFields(form.controls.userDefinedFields, userDefinedFieldPosition.employeeInfoLeft, true); track userDefinedFieldGroup) {
          <app-user-defined-field
            [form]="form"
            [userDefinedFieldGroup]="userDefinedFieldGroup">
          </app-user-defined-field>
        }
      </div>
      <div class="column-container">
        @for(userDefinedFieldGroup of positionUserDefinedFields(form.controls.userDefinedFields, userDefinedFieldPosition.employeeInfoRight); track userDefinedFieldGroup) {
          <app-user-defined-field
            [form]="form"
            [userDefinedFieldGroup]="userDefinedFieldGroup">
          </app-user-defined-field>
        }
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!isSubmitting && this.form.errors?.msError) {
    <mat-error class="mse-form-error caption">{{ this.form.errors?.msError }}</mat-error>
  }
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{ data.sysTextDialog.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysTextDialog.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ data.sysTextDialog.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>